var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "common page-btns-father" }, [
    _c("div", { staticClass: "page-btns-main" }, [
      _c(
        "div",
        { staticClass: "page-main no-shadow" },
        [
          _c(
            "a-steps",
            { staticClass: "common-step", attrs: { current: _vm.current } },
            _vm._l(_vm.steps, function(item) {
              return _c("a-step", {
                key: item.title,
                attrs: { title: item.title }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {},
        [
          _c(
            "keep-alive",
            [
              _c(_vm.steps[_vm.current].comp, {
                ref: "bankComp",
                tag: "component",
                attrs: {
                  params: _vm.steps[_vm.current].params,
                  text: _vm.steps[_vm.current].text
                },
                on: {
                  "update:params": function($event) {
                    return _vm.$set(_vm.steps[_vm.current], "params", $event)
                  },
                  success: _vm.success
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "spaceCenter page-bottom-btns" },
      [
        _vm.current == 0
          ? [
              _c(
                "a-button",
                {
                  staticClass: "btn-big",
                  staticStyle: { "margin-left": "8px" },
                  on: { click: _vm.goback }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  staticClass: "btn-big",
                  staticStyle: { "margin-left": "8px" },
                  on: { click: _vm.next }
                },
                [_vm._v("下一步")]
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.current == 1
          ? [
              _c(
                "a-button",
                {
                  staticClass: "btn-big",
                  staticStyle: { "margin-left": "8px" },
                  on: { click: _vm.prev }
                },
                [_vm._v("上一步")]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  staticClass: "btn-big",
                  staticStyle: { "margin-left": "8px" },
                  on: { click: _vm.goback }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  staticClass: "btn-big",
                  staticStyle: { "margin-left": "8px" },
                  on: { click: _vm.next }
                },
                [_vm._v("下一步")]
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.current == 2
          ? [
              _c(
                "a-button",
                {
                  staticClass: "btn-big",
                  staticStyle: { "margin-left": "8px" },
                  on: { click: _vm.prev }
                },
                [_vm._v("上一步")]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  staticClass: "btn-big",
                  staticStyle: { "margin-left": "8px" },
                  on: { click: _vm.goback }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  staticClass: "btn-big",
                  staticStyle: { "margin-left": "8px" },
                  on: { click: _vm.submit }
                },
                [_vm._v("提交")]
              )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7dc638a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dc638a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/circulation/gold-financing/gold-financing-steps/index.vue
// module id = izMI
// module chunks = 1